module.exports = __webpack_public_path__ + "doctors.74a89fe9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/logos/doctors.png
// module id = 4bxg
// module chunks = 0